import React from 'react'
import PropTypes from 'prop-types'
import { HeroImage, HeroMain, HeroText } from './index.style'
import Container from '@components/Container'
import RichText from '@components/RichText'
import { GatsbyImage } from 'gatsby-plugin-image'
import Spacer from '@components/Spacer'
import AnimateSlideIn from '@components/animation/AnimateSlideIn'

const Hero = ({ title, textA, textB, image }) => {

  return (
    <HeroMain>
      <Container>
        <Spacer size={200} />
        <RichText content={title} as="h1" />
        <Spacer size={30} />
        <HeroImage>
          <GatsbyImage
            image={image.gatsbyImageData}
            alt={image.description}
          />
        </HeroImage>
        {textA &&
          <HeroText>{textA}</HeroText>
        }
        <Spacer size={60} />
      </Container>
    </HeroMain>
  )
}

Hero.propTypes = {
  title: PropTypes.object,
  image: PropTypes.object,
}

export default Hero
